import { render, staticRenderFns } from "./txPage.vue?vue&type=template&id=d7fa672a"
import script from "./txPage.vue?vue&type=script&lang=js"
export * from "./txPage.vue?vue&type=script&lang=js"
import style0 from "./txPage.vue?vue&type=style&index=0&id=d7fa672a&prod&lang=scss"
import style1 from "./txPage.vue?vue&type=style&index=1&id=d7fa672a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports